import type { AgBarSeriesOptions } from 'ag-charts-enterprise';

import type { SearchableSelectConfig } from '@/components/SearchableSelect';
import PERMISSIONS from '@/constants/auth.constants';

export const VMP_TABS = [
  {
    label: 'Vulnerabilities',
    path: '/vulnerability-management/vulnerabilities',
    value: 0,
    ariaLabel: 'vulnerabilities-tab',
    permissions: PERMISSIONS.VMP_READ
  },
  {
    label: 'Remediations',
    path: '/vulnerability-management/remediations',
    value: 1,
    ariaLabel: 'remediations-tab',
    permissions: PERMISSIONS.VMP_READ
  }
];

export const VMPE_CRITICALITY_PRIORITIES = {
  Critical: 5,
  High: 4,
  Medium: 3,
  Low: 2,
  None: 1
};

export const VMP_SEARCHABLE_SELECT_FILTERS_ASSETS: SearchableSelectConfig[] = [
  // {
  //   field: 'risk_score',
  //   title: 'Risk Score',
  //   config: {
  //     searchable: true,
  //     showCounts: true,
  //     variant: 'dropdown'
  //   },
  //   filterOptions: []
  // },
  // {
  //   field: 'importance',
  //   title: 'Importance',
  //   config: {
  //     searchable: true,
  //     showCounts: true,
  //     variant: 'dropdown'
  //   },
  //   filterOptions: []
  // },
  {
    field: 'shield_type',
    title: 'Scanner Type',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  // this is a special case for the asset age filter (set to hidden) to show the correct label in the search input chip
  {
    field: 'created_in_shield',
    title: 'Asset Age',
    config: {
      searchable: false,
      showCounts: false
    },
    filterOptions: [],
    hidden: true
  },
  {
    field: 'operating_system',
    title: 'Operating System',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  }
];

export const VMP_SEARCHABLE_SELECT_FILTERS_REMEDIATIONS: SearchableSelectConfig[] =
  [
    {
      field: 'cvss_level',
      title: 'CVSS Severity',
      config: {
        searchable: true,
        showCounts: true,
        variant: 'dropdown'
      },
      filterOptions: []
    },
    {
      field: 'pondurance_score',
      title: 'Pondurance Score',
      config: {
        searchable: true,
        showCounts: true,
        variant: 'dropdown'
      },
      filterOptions: []
    },
    // this is a special case for the vulnerabilitiy and remediation category filter (set to hidden) to show the correct label in the search input chip
    {
      field: 'category',
      title: 'Category',
      config: {
        searchable: false,
        showCounts: false
      },
      filterOptions: [],
      hidden: true
    }
  ];

export const VMP_SEARCHABLE_SELECT_FILTERS_VULNERABILITIES: SearchableSelectConfig[] =
  [
    {
      // field matches the base_field name in the filter config; the "Is Null" operator
      // is applied when building the request (see VulnerabilityManagementSearch.tsx)
      field: 'date_remediated',
      title: 'Remediated',
      config: {
        searchable: false,
        showCounts: true,
        variant: 'buttongroup'
      },
      filterOptions: [
        {
          id: 1,
          label: 'Not Remediated',
          value: 'Null'
        },
        {
          id: 2,
          label: 'Remediated',
          value: 'NotNull'
        }
      ]
    },
    {
      field: 'cvss_level',
      title: 'CVSS Severity',
      config: {
        searchable: true,
        showCounts: true,
        variant: 'dropdown'
      },
      filterOptions: []
    },
    {
      field: 'pondurance_score',
      title: 'Pondurance Score',
      config: {
        searchable: true,
        showCounts: true,
        variant: 'dropdown'
      },
      filterOptions: []
    },
    // this is a special case for the vulnerabilitiy and remediation category filter (set to hidden) to show the correct label in the search input chip
    {
      field: 'category',
      title: 'Category',
      config: {
        searchable: false,
        showCounts: false
      },
      filterOptions: [],
      hidden: true
    },
    {
      field: 'scanner_type',
      title: 'Scanner Type',
      config: {
        searchable: true,
        showCounts: true,
        variant: 'dropdown'
      },
      filterOptions: []
    }
  ];

export const DISABLE_SHIELD_SYNC_KEY = 'shieldSyncLastClick';
export const DISABLE_SHIELD_SYNC_DURATION = 60000; // 1 minute timeout

export default VMP_TABS;

// for removing "shield" from specific column names in export files
export const KEY_MAPS: { [key: string]: string } = {
  created_in_shield: 'first_seen',
  max_shield_exposure_index: 'max_exposure_index',
  original_shield_asset_id: 'original_asset_id',
  shield_created_at: 'created_at',
  shield_exposure_index: 'exposure_index',
  shield_type: 'type',
  shield_updated_at: 'updated_at'
};

export const REMEDIATIONS_BAR_SERIES: AgBarSeriesOptions[] = [
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'count',
    yName: 'Remediations',
    fill: '#008ffb'
  }
];

export const VULNERABILITIES_SEARCH_FIELD_LABELS: Record<string, string> = {
  cvss: 'CVSS',
  cve: 'CVE',
  cvss_level: 'CVSS Level',
  vmp_severity: 'VMP Severity',
  vmp_exposure_index: 'VMP Exposure Index',
  os_name: 'OS Name'
};

export const VULNERABILITIES_HIDE_COUNTS_FIELDS: string[] = [
  'known_ransomware_campaign_use',
  'exploited'
];
